import { render, staticRenderFns } from "./table-new.vue?vue&type=template&id=beee8b38"
import script from "./table-new.vue?vue&type=script&lang=js"
export * from "./table-new.vue?vue&type=script&lang=js"
import style0 from "./table-new.vue?vue&type=style&index=0&id=beee8b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports